//Provider portal
const ProviderRoutes = {
    path: "/provider",
    component: () =>
        import(
            /* webpackChunkName: "ProviderBase.vue" */
            "@/modules/provider/views/ProviderBase.vue"
        ),
    meta: {
        theme: "provider",
        crumbName: "Provider",
    },
    children: [
        //Home will be the patient list
        {
            path: "/",
            component: () =>
                import(
                    /* webpackChunkName: "PatientList" */
                    "@/modules/provider/views/PatientListView.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "patientListLink",
                menuText: "Patient List",
                menuOrder: 0,
                crumbName: "Patient List",
            },
        },
        {
            path: "/participants",
            component: () =>
                import(
                    "@/modules/provider/views/ParticipantListView.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "participantListLink",
                menuText: "Participant List",
                menuOrder: 1,
                crumbName: "Participant List",
            },
        },
        {
            path: "settings",
            component: () =>
                import(
                    /* webpackChunkName: "ProviderSettingsBase.vue" */
                    "@/modules/provider/views/settings/SettingsBase.vue"
                ),
            meta: {
                crumbName: "Settings",
                //menu: "provider",
                //section: "home",
                //menuID: "SettingsLink",
                //menuText: "Settings",
                //menuOrder: 4,
            },
            children: [
                {
                    path: "account",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderAccount" */
                            "@/modules/provider/views/settings/AccountView.vue"
                        ),
                    meta: {
                        crumbName: "Account",
                    },
                },
                {
                    path: "clinician",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderClinicianInfo" */
                            "@/modules/provider/views/settings/ClinicianInfoView.vue"
                        ),
                    meta: {
                        crumbName: "Clinician",
                    },
                },
                {
                    path: "subscriptions",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderSubscriptions" */
                            "@/modules/provider/views/settings/SubscriptionsView.vue"
                        ),
                    meta: {
                        crumbName: "Subscriptions",
                    },
                },
                {
                    path: "contracts",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderContracts" */
                            "@/modules/provider/views/settings/ContractsView.vue"
                        ),
                    meta: {
                        crumbName: "Contracts",
                    },
                },
                {
                    path: "settings",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderSettings" */
                            "@/modules/provider/views/settings/SettingsView.vue"
                        ),
                    meta: {
                        crumbName: "Settings",
                    },
                },
            ],
        },
        {
            path: "invite",
            component: () =>
                import(
                    /* webpackChunkName: "ProviderInvite" */
                    "@/modules/provider/views/management/InvitePatientView.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "patientInviteLink",
                menuText: "Invite Patient",
                menuOrder: -1,
                crumbName: "Invite Patient",
            },
        },
        {
            path: "add",
            component: () =>
                import(
                    /* webpackChunkName: "ProviderAddPatient" */
                    "@/modules/provider/views/management/AddPatientView.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "addPatientLink",
                menuText: "Add Patient",
                menuOrder: 2,
                crumbName: "Add patient",
            },
        },
        {
            path: "calendar",
            component: () =>
                import(
                    /* webpackChunkName: "ProviderCalendar" */
                    "@/modules/provider/views/management/CalendarView.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "appointmentCalendarLink",
                menuText: "Calendar",
                menuOrder: 3,
                crumbName: "Calendar",
            },
        },
        {
            path: "scheduler",
            component: () =>
                import(
                    /* webpackChunkName: "ProviderScheduler" */
                    "@/modules/provider/views/management/SchedulerView.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "appointmentSchedulerLink",
                menuText: "Scheduler",
                menuOrder: 3,
                crumbName: "Scheduler",
            },
        },
        {
            path: "message",
            component: () =>
                import(
                    "@/modules/provider/views/management/ProviderMessageView.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "messageLink",
                menuText: "Messages",
                menuOrder: 4,
                crumbName: "Messages",
            },
        },
        // organization account
        {
            path: "accountconsole",
            component: () => import("@/modules/provider/account/views/AccountBase.vue"),
            meta: { breadcrum: "Account Console"},
            children: [
                {
                    path: "orgaccount",
                    component: () => import("@/modules/provider/account/views/OrgAccountView.vue"),
                    meta: {
                        menu: "provider",
                        section: "account",
                        menuID: "orgAccountLink",
                        menuText: "Organization Account",
                        menuOrder: 0,
                        crumbName: "Organization Account",
                    },
                },
                {
                    path: "services",
                    component: () => import("@/modules/provider/account/views/OrgServicesView.vue"),
                    meta: {
                        menu: "provider",
                        section: "account",
                        menuID: "orgServicesLink",
                        menuText: "Services",
                        menuOrder: 1,
                        crumbName: "Services",
                    },
                },
                {
                    path: "report",
                    component: () => import("@/modules/provider/account/views/OrgReportView.vue"),
                    meta: {
                        menu: "provider",
                        section: "account",
                        menuID: "orgReportLink",
                        menuText: "Report",
                        menuOrder: 2,
                        crumbName: "Report",
                    },
                },
                {
                    path: "review",
                    component: () => import("@/modules/provider/account/views/OrgReviewView.vue"),
                    meta: {
                        menu: "provider",
                        section: "account",
                        menuID: "orgReviewLink",
                        menuText: "Review",
                        menuOrder: 3,
                        crumbName: "Review",
                    },
                },
                {
                    path: "billing",
                    component: () => import("@/modules/provider/account/views/OrgBillingView.vue"),
                    meta: {
                        menu: "provider",
                        section: "account",
                        menuID: "orgBillingLink",
                        menuText: "Billing",
                        menuOrder: 4,
                        crumbName: "Billing",
                    },
                },
            ],
        },


        {
            path: "admin",
            component: () =>
                import(
                    "@/modules/provider/admin/views/AdminBase.vue"
                ),
            meta: {
                menu: "provider",
                section: "home",
                menuID: "admin-nav",
                menuText: "Admin Console",
                menuOrder: -1,
                crumbName: "Admin",
            },
            children: [
                {
                    path: "providers",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ProviderListView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "home",
                        menuParent: "admin-nav",
                        menuID: "providerLink",
                        menuText: "Provider List",
                        menuOrder: 0,
                        crumbName: "Provider List",
                    },
                },

                {
                    path: "reporttemplatelist",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ReportTemplatesView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "home",
                        menuParent: "admin-nav",
                        menuID: "reporttemplatelistLink",
                        menuText: "Report Templates",
                        menuOrder: 1,
                        crumbName: "Provider List",
                    },
                },
                {
                    path: "insurances",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/InsurancesView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "home",
                        menuParent: "admin-nav",
                        menuID: "insurances",
                        menuText: "Insurances",
                        menuOrder: 2,
                        crumbName: "Insurances",
                    },
                },
                {
                    path: "cptcodes",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/CPTCodesView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "home",
                        menuParent: "admin-nav",
                        menuID: "cptcode",
                        menuText: "CPT Codes",
                        menuOrder: 3,
                        crumbName: "CPT Code",
                    },
                },
             
                {
                    path: "consentcontract",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ConsentContractsView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "home",
                        menuParent: "admin-nav",
                        menuID: "consentcontract",
                        menuText: "Consents/Contracts",
                        menuOrder: 5,
                        crumbName: "Consent Contract",
                    },
                },
                {
                    path: "consentcontractedit/:id",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ConsentContractView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "home",
                        menuParent: "admin-nav",
                    },
                },
                
            ]
        },

        //All patient specific routes
        {
            path: "patient/:patient_id",
            component: () =>
                import(
                    /* webpackChunkName: "ProviderPatient" */
                    "@/modules/provider/views/patient/PatientBase.vue"
                ),
            meta: {
                menu: "provider",
                section: "patient",
                menuID: "profile-nav",
                menuText: "Profile",
                menuOrder: 2,
                crumbName: "Patient Profile",
            },
            children: [
                {
                    path: "overview",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderOverView.vue" */
                            "@/modules/provider/views/patient/OverviewView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "overviewLink",
                        menuText: "Overview",
                        menuOrder: 0,
                        crumbName: "Home",
                        profilePage: "Overview",
                    },
                },
                {
                    path: "profile/identity",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientIdentity" */
                            "@/modules/profile/views/IdentityView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "identityLink",
                        menuText: "Identity",
                        menuOrder: 0,
                        crumbName: "Identity",
                        profilePage: "Identity",
                    },
                },
                {
                    path: "profile/reason",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientReason" */
                            "@/modules/profile/views/ReasonView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "reasonLink",
                        menuText: "Reason",
                        menuOrder: 1,
                        crumbName: "Reason",
                        profilePage: "Reason",
                    },
                },
                {
                    path: "profile/family",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientFamily" */
                            "@/modules/profile/views/FamilyView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "familyLink",
                        menuText: "Family",
                        menuOrder: 2,
                        crumbName: "Family",
                        profilePage: "Family",
                    },
                },
                {
                    path: "profile/contacts",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientContacts" */
                            "@/modules/profile/views/ContactsView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "contactsLink",
                        menuText: "Contacts",
                        menuOrder: 3,
                        crumbName: "Contacts",
                        profilePage: "Contacts",
                    },
                },
                {
                    path: "profile/medical",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientMedical" */
                            "@/modules/profile/views/MedicalView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "medicalLink",
                        menuText: "Medical",
                        menuOrder: 4,
                        crumbName: "Medical",
                        profilePage: "Medical",
                    },
                },
                {
                    path: "profile/substance",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientSubstance" */
                            "@/modules/profile/views/SubstanceView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "substanceLink",
                        menuText: "Substance",
                        menuOrder: 5,
                        crumbName: "Substance",
                        profilePage: "Substance",
                    },
                },
                {
                    path: "profile/social",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientSocial" */
                            "@/modules/profile/views/SocialView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "socialLink",
                        menuText: "Social",
                        menuOrder: 6,
                        crumbName: "Social",
                        profilePage: "Social",
                    },
                },
                {
                    path: "profile/education",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientEducation" */
                            "@/modules/profile/views/EducationView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "educationLink",
                        menuText: "Education",
                        menuOrder: 7,
                        crumbName: "Education",
                        profilePage: "Education",
                    },
                },
                {
                    path: "profile/employment",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientEmployment" */
                            "@/modules/profile/views/EmploymentView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "profile-nav",
                        menuID: "employmentLink",
                        menuText: "Employment",
                        menuOrder: 8,
                        crumbName: "Employment",
                        profilePage: "Employment",
                    },
                },
                {
                    path: "profile/culture",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientCulture" */
                            "@/modules/profile/views/CultureView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "cultureLink",
                        menuParent: "profile-nav",
                        menuText: "Culture",
                        menuOrder: 9,
                        crumbName: "Culture",
                        profilePage: "Culture",
                    },
                },
                {
                    path: "profile/Insurance",
                    component: () =>
                        import(
                            /* webpackChunkName: "PatientCulture" */
                            /* "@/modules/provider/views/patient/InsuranceView.vue"*/
                            "@/modules/profile/views/InsuranceView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "insuranceLink",
                        menuParent: "profile-nav",
                        menuText: "Insurance",
                        menuOrder: 10,
                        crumbName: "Insurance",
                        profilePage: "Insurance",
                    },
                },
                /*
                {
                    path: "treatment",
                    component: () =>
                        import(
                            "@/modules/provider/views/patient/TreatmentPlanView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "treatmentLink",
                        menuText: "Treatment Plan",
                        menuOrder: 4,
                        crumbName: "Treatment",
                    }
                },*/
                {
                    path: "treatmentai",
                    component: () =>
                        import(
                            "@/modules/provider/views/patient/treatment/TreatmentAIBase.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "treatmentAILink",
                        menuText: "AI Treatment Plan",
                        menuOrder: 5,
                        crumbName: "TreatmentAI",
                    },
                    children: [
                        {
                            path: "treatmentgene",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/treatment/TreatmentGenerator.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "treatmentAILink",
                                menuID: "treatmentPlanGen",
                                menuText: "AI Treatment Plan Generator",
                                menuOrder: 0,
                                crumbName: "treatmentGene",
                            },
                        },
                        {
                            path: "treatmenthist",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/treatment/TreatmentHistory.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "treatmentAILink",
                                menuID: "treatmentPlanHist",
                                menuText: "Treatment Plan History",
                                menuOrder: 1,
                                crumbName: "treatmentHist",
                            },
                        },
                        {
                            path: "treatmentedit",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/treatment/TreatmentEdit.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "treatmentAILink",
                                menuID: "treatmentPlanEdit",
                                menuText: "Edit Treatment Prompts",
                                menuOrder: 2,
                                crumbName: "treatmentEdit",
                            },
                        },
                    ]
                },

                {
                    path: "diagnostic",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderDiagnostic" */
                            "@/modules/provider/views/patient/diagnostic/DiagnosticBase.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "diag-nav",
                        menuText: "Diagnostic",
                        menuOrder: 3,
                        crumbName: "Diagnostic",
                    },
                    children: [
                        {
                            path: "diagnosis",
                            component: () =>
                                import(
                                    /* webpackChunkName: "ProviderDiagnosis" */
                                    "@/modules/provider/views/patient/diagnostic/DiagnosesView.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "diag-nav",
                                menuID: "diagnosisLink",
                                menuText: "Diagnosis",
                                menuOrder: 0,
                                crumbName: "Diagnosis",
                            },
                        },
                        {
                            path: "evaluation",
                            component: () =>
                                import(
                                    /* webpackChunkName: "ProviderEvaluation" */
                                    "@/modules/provider/views/patient/diagnostic/EvaluationsView.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "diag-nav",
                                menuID: "evaluationLink",
                                menuText: "Evaluation",
                                menuOrder: 1,
                                crumbName: "Evaluation",
                            },
                        }
                    ],
                },
                {
                    path: "appointments/list",
                    component: () =>
                        import(
                            /* webpackChunkName: "AppointmentList" */
                            "@/modules/provider/views/patient/appointments/AppointmentListView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "appointment-nav",
                        parentText: "Appointments",
                        parentOrder: 1,
                        menuID: "appointmentListLink",
                        menuText: "List Appointments",
                        menuOrder: 0,
                        crumbName: "List",
                    },
                },
                {
                    path: "appointments/new",
                    component: () =>
                        import(
                            /* webpackChunkName: "NewAppointment" */
                            "@/modules/provider/views/patient/appointments/NewAppointmentView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuParent: "appointment-nav",
                        menuID: "newAppointmentLink",
                        menuText: "New Appointment",
                        menuOrder: 1,
                        crumbName: "New Appointment",
                    },
                },
                {
                    path: "documents",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderDocuments" */
                            "@/modules/provider/views/patient/DocumentsView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "documentsLink",
                        menuText: "Documents",
                        menuOrder: 6,
                        crumbName: "Documents",
                    },
                },
                {
                    path: "assessments",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderAssessmentsView.vue" */
                            "@/modules/provider/views/patient/AssessmentsView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "assessmentLink",
                        menuText: "Assessments",
                        menuOrder: 7,
                        crumbName: "Assessments",
                    },
                },
                {
                    path: "notes/",
                    component: () =>
                        import(
                            /* webpackChunkName: "ProviderNotes" */
                            "@/modules/provider/views/patient/NotesView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "notesLink",
                        menuText: "Notes",
                        menuOrder: 8,
                        crumbName: "Patient Notes",
                    },
                },
                //{
                //    path: "report/",
                //    component: () =>
                //        import(
                //            "@/modules/provider/views/patient/ReportView.vue"
                //        ),
                //    meta: {
                //        menu: "provider",
                //        section: "patient",
                //        menuID: "reportLink",
                //        menuText: "Mental Health Report",
                //        menuOrder: 9,
                //        crumbName: "Mental Health Report",
                //    },
                //},
                {
                    path: "report",
                    component: () =>
                        import(
                              "@/modules/provider/views/patient/reports/ReportsBase.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "report-nav",
                        menuText: "Custom Reports",
                        menuOrder: 9,
                        crumbName: "Custom Reports",
                    },
                    children: [
                        {
                            path: "reports",
                            component: () =>
                                import(
 
                                    "@/modules/provider/views/patient/reports/ReportsView.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "report-nav",
                                menuID: "reportsLink",
                                menuText: "Reports",
                                menuOrder: 0,
                                crumbName: "Reports List",
                            },
                        },
                        //{
                        //    path: "resources",
                        //    component: () =>
                        //        import(
                        //              "@/modules/provider/views/patient/reports/ResourcesView.vue"
                        //        ),
                        //    meta: {
                        //        menu: "provider",
                        //        section: "patient",
                        //        menuParent: "report-nav",
                        //        menuID: "resourcesLink",
                        //        menuText: "Resources",
                        //        menuOrder: 1,
                        //        crumbName: "Resources",
                        //    },
                        //},
                        {
                            path: "reporttemplates",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/reports/ReportTemplatesView.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "report-nav",
                                menuID: "reporttemplatesLink",
                                menuText: "Report Templates",
                                menuOrder: 2,
                                crumbName: "Report Templates",
                            },
                        },
                        {
                            path: "reports/:id",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/reports/ReportGeneratorView.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "report-nav",
                            },
                        },
                    ],
                },
                {
                    path: "dashboard",
                    component: () =>
                        import(
                            "@/modules/provider/views/patient/dashboard/DashboardBase.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "patient",
                        menuID: "dash-nav",
                        menuText: "Dashboard",
                        menuOrder: 10,
                        crumbName: "Dashboard",
                    },
                    children: [
                        {
                            path: "report",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/dashboard/ReportView.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "dash-nav",
                                menuID: "reportLink",
                                menuText: "Report",
                                menuOrder: 0,
                                crumbName: "Report",
                            },
                        },
                        {
                            path: "consents",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/dashboard/ConsentsView.vue"
                                ),
                            meta: {
                                menu: "provider",
                                section: "patient",
                                menuParent: "dash-nav",
                                menuID: "consentLink",
                                menuText: "Consents",
                                menuOrder: 1,
                                crumbName: "Consents",
                            },
                        },
                        {
                            path: "consentsignedform/:consentsignedform_id",
                            component: () =>
                                import(
                                    "@/modules/provider/views/patient/dashboard/ConsentSignedForm.vue"
                                ),

                        },
                    ],
                },
                 //{
                 //  path: "insurance",
                 //  component: () => import(/* webpackChunkName: "ProviderInsurance" */'@/modules/provider/views/patient/InsuranceView'),
                 //  meta: {
                 //    menu: "provider",
                 //    section: "patient",
                 //    menuID: "insuranceLink",
                 //    menuText: "Insurance",
                 //    menuOrder: 9,
                 //    crumbName: "Insurance",
                 //  },
                 //},
            ],
        },
        //All practice specific routes
        {
            path: "/practice",
            component: () =>
                import(
                    /* webpackChunkName: "PracticeBase" */
                    "@/modules/provider/practice/PracticeBase.vue"
                ),
            children: [
                {
                    path: "list",
                    component: () =>
                        import(
                            /* webpackChunkName: "PracticeList" */
                            "@/modules/provider/practice/PracticeList.vue"
                        ),
                },
            ]
        },
        {
            path: "adminconsole",
            component: () =>
                import(
                    "@/modules/provider/admin/views/AdminBase.vue"
                ),
            meta: {
                menu: "provider",
                section: "admin",
            
            },

            children: [
                {
                    path: "providers",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ProviderListView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                        menuID: "providerLink",
                        menuText: "Provider List",
                        menuOrder: 0,
                        crumbName: "Provider List",
                    },
                },
                {
                    path: "scheduler",
                    component: () =>
                        import(
                            "@/modules/provider/views/management/SchedulerView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                        menuID: "schedulerLink",
                        menuText: "Scheduler",
                        menuOrder: 1,
                        crumbName: "Scheduler",
                    },
                },
                {
                    path: "insurances",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/InsurancesView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                        menuID: "insurances",
                        menuText: "Insurances",
                        menuOrder: 2,
                        crumbName: "Insurances",
                    },
                },
                {
                    path: "cptcodes",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/CPTCodesView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                        menuID: "cptcode",
                        menuText: "CPT Codes",
                        menuOrder:3,
                        crumbName: "CPT Code",
                    },
                },
                {
                    path: "reporttemplatelist",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ReportTemplatesView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                        menuID: "reporttemplatelistLink",
                        menuText: "Report Templates",
                        menuOrder:4,
                        crumbName: "Insurances",
                    },
                },

                {
                    path: "consentcontract",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ConsentContractsView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                        menuID: "consentcontract",
                        menuText: "Consents/Contracts",
                        menuOrder: 5,
                        crumbName: "Consent Contract",
                    },
                },
                {
                    path: "consentcontractedit/:id",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/ConsentContractView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                    },
                },

                {
                    path: "accounts",
                    component: () =>
                        import(
                            "@/modules/provider/admin/views/AccountListView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "admin",
                        menuID: "accountLink",
                        menuText: "Account List",
                        menuOrder: 6,
                        crumbName: "Account List",
                    },
                },
            ]
        },
        {
            path: "cotherapist",
            component: () =>
                import(
                    "@/modules/provider/cotherapist/views/CoTherapistBase.vue"
                ),
            meta: {
                menu: "provider",
                section: "cotherapist",

            },

            children: [
                {
                    path: "chat",
                    component: () =>
                        import(
                            "@/modules/provider/cotherapist/views/ChatView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "cotherapist",
                        menuID: "chatLink",
                        menuText: "Chat",
                        menuOrder: 0,
                        crumbName: "Chat",
                    },
                },
                {
                    path: "prompts",
                    component: () =>
                        import(
                            "@/modules/provider/cotherapist/views/PromptsView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "cotherapist",
                        menuID: "promptsLink",
                        menuText: "prompts",
                        menuOrder: 1,
                        crumbName: "prompts",
                    },
                },
                {
                    path: "promptnew",
                    component: () =>
                        import(
                            "@/modules/provider/cotherapist/views/PromptNewView.vue"
                        ),
                    meta: {
                        menu: "provider",
                        section: "cotherapist",
                        menuID: "promptnewLink",
                        menuText: "Prompt Creation",
                        menuOrder: 2,
                        crumbName: "Prompt Creation",
                    },
                },
                
            ]
        },
    ],
};
export default ProviderRoutes;
